import { Component, Input, OnInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {ApiService} from "../../core/api/api.service";
import {AccessControlService} from "../../core/access-control/access-control.service";
import {customerRole} from "../../core/access-roles/customer.role";
import {employeeRole} from "../../core/access-roles/employee.role";

@Component({
    selector: 'bergh-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    standalone: false
})
export class DocumentsComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() link: boolean;
  @Input() id: string;
  public docId: string;
  @Output() openModal: EventEmitter<void> = new EventEmitter();
  isShow = true;
  isLinkDelink = false;
  isCustomer = false;
  constructor(
    private _api: ApiService,
    private _elemRef: ElementRef,
    private _toastr: ToastrService,
    private _accessControl: AccessControlService
  ) { }

  ngOnInit(): void {
    this.isCustomer = this._accessControl.isCustomer();
    this.isShow = !(this._accessControl.isEmployee() || this.isCustomer);
    this.link = this.link === undefined ? true : this.link;
  }

  openDelete(element){
    this.removeAllPopup();
    let elem = element.parentElement;
    if (elem.classList.contains("active") ) {
      elem.classList.remove("active");
    } else {
      elem.classList.add("active");
    }
  }

  cancelDelete(element){
    let elem = element.parentElement.parentElement.parentElement;
    elem.classList.remove("active");
  }

  removeAllPopup(){
    let elements = this._elemRef.nativeElement.querySelectorAll('.btn-delete');
      for (let index = 0; index < elements.length; index++) {
        elements[index].classList.remove("active");
      }
  }

  deleteDocument(_id){
    this._api.request('deleteProjectDocument',`${this.id}/document/${_id}`).subscribe((res: any) => {
      this.getAllDocuments(this.id);
    }, (error: any) => {
      console.error(error)
      this.getAllDocuments(this.id);
    })
  }

  publishDocument(_id, status) {
    let payLoad = {
      publish: !status
    }
    this._api.request('changeStatusProjectDocument',payLoad,`${this.id}/document/${_id}`).subscribe((res: any) => {
      this._toastr.success('Status gewijzigd!','Success')
      this.getAllDocuments(this.id);
    }, (error: any) => {
      console.error(error)
    })
  }

  getAllDocuments(_id){
    this._api.request('getProjectDocument',`${_id}/document`).subscribe((res: any) => {
      this.data = res;
    }, (error: any) => {
      console.error(error)
    })
  }

  openLinkDelinkModel(data) {
    this.isLinkDelink = true;
    this.docId = data;
  }

}
